module.exports = "data:image/svg+xml;base64,77u/PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2IiB2aWV3Qm94PSIwIDAgNDggNDgiIGZpbGw9InJnYmEoNTgsIDE5MywgMTI2LCAxKSI+CiAgICA8cGF0aCBkPSJNMCAwaDQ4djQ4SDB6IiBmaWxsPSJub25lIj48L3BhdGg+CiAgICA8cGF0aCBkPSJNMjQgNEMxMi45NSA0IDQgMTIuOTUgNCAyNGMwIDExLjA0IDguOTUgMjAgMjAgMjAgMTEuMDQgMCAyMC04Ljk2IDIwLTIwIDAtMTEuMDUtOC45Ni0yMC0yMC0yMHptLTQgMzBMMTAgMjRsMi44My0yLjgzTDIwIDI4LjM0bDE1LjE3LTE1LjE3TDM4IDE2IDIwIDM0eiI+PC9wYXRoPgo8L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/views/login/img/right.svg
// module id = lHIP
// module chunks = 3